export default {
  state: {
    active: false,
    floatingBanner: {
      visible: true,
    },
    modalLaws: true,
  },
  getters: {
    loaderActive(state) {
      return state.active;
    },
    getFloatingBanner(state) {
      return state.floatingBanner;
    },
    // Exibição da modal na página de Leis e Decretos
    getModalLaws(state) {
      return state.modalLaws;
    },
  },
  mutations: {
    updateLoaderState(state, value) {
      state.active = value;
    },
    hideFloatingBanner(state) {
      state.floatingBanner.visible = !state.floatingBanner.visible;
    },
    setModalLaws(state) {
      state.modalLaws = !state.modalLaws;
    },
  },
};
